var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFriendGetFriend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5878 7L15.4368 10.5209H18.6L14.2742 18L14.9923 12.8978H12L12.7406 7H16.5878Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19C18.866 19 22 15.866 22 12C22 8.13401 18.866 5 15 5C11.134 5 8 8.13401 8 12C8 15.866 11.134 19 15 19ZM15 21C19.9706 21 24 16.9706 24 12C24 7.02944 19.9706 3 15 3C10.0294 3 6 7.02944 6 12C6 16.9706 10.0294 21 15 21Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33306 18.9922C9.22269 18.9974 9.11165 19 9 19C5.13401 19 2 15.866 2 12C2 8.13401 5.13401 5 9 5C9.11165 5 9.22269 5.00261 9.33306 5.00778C10.1225 4.36721 11.0225 3.85762 12 3.51212C11.0617 3.18046 10.0519 3 9 3C4.02944 3 0 7.02944 0 12C0 16.9706 4.02944 21 9 21C10.0519 21 11.0617 20.8195 12 20.4879C11.0225 20.1424 10.1225 19.6328 9.33306 18.9922Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFriendGetFriend);
export default __webpack_public_path__ + "static/media/icon-friend-get-friend.3665909e0b8e95dd619a2eb441ff9339.svg";
export { ForwardRef as ReactComponent };